import React from 'react'
import styled, {css} from 'styled-components'
import {colors} from '../../../colors'
import {Text} from '../Text'

export type SwitchProps = React.InputHTMLAttributes<HTMLInputElement>

export const checkedColors = {
  default: colors.system.green,
  reversed: colors.system.red
}

export const Switch: React.FC<SwitchProps> = props => {
  const {style, ...inputProps} = props
  return (
    <SwitchContainer style={style}>
      <SwitchInput {...(inputProps as React.InputHTMLAttributes<HTMLInputElement>)} type="checkbox"></SwitchInput>
      <SwitchToggle checked={props.checked} checkedColor={checkedColors.default}></SwitchToggle>
      <SwitchLabel color={props.checked ? colors.system.grey_1 : colors.system.white}>Off</SwitchLabel>
      <SwitchLabel color={props.checked ? colors.system.white : colors.system.grey_1}>On</SwitchLabel>
    </SwitchContainer>
  )
}

export const SwitchContainer = styled.label`
  display: inline-block;
  position: relative;
  width: 6rem;
  height: 2rem;
  background-color: ${colors.system.lightGrey_5};
  border-radius: 1rem;
  cursor: pointer;
`

export const SwitchInput = styled.input`
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
`

export const SwitchToggle = styled.span<{checked?: boolean; checkedColor: string}>(
  ({checked, checkedColor}) => css`
    display: inline-block;
    position: absolute;
    top: 0;
    left: ${checked ? '3rem' : '0'};
    width: 3rem;
    height: 2rem;
    background-color: ${checked ? checkedColor : colors.system.grey_1};
    border-radius: 1rem;
    transition-property: left, background-color;
    transition-duration: 0.3s;
    transition-timing-function: ease-out;
  `
)

export const SwitchLabel = styled(Text).attrs({size: 'S', mono: true})`
  display: inline-flex;
  position: relative;
  width: 3rem;
  height: 2rem;
  align-items: center;
  justify-content: center;
  transition: color 0.3s ease-out;
  user-select: none;
`
